import React, { useState, useEffect } from 'react';
import HomeTopBar from './HomeTopBar';
import axios from 'axios';
import { provinces } from '../constants';
import { local_market } from '../constants';
import BankConsiderationChart from '../charts/BankConsideration/BankConsiderationChart';
import BankConsiderationPrivateChart from '../charts/BankConsideration/BankConsiderationPrivateChart';
import BankConsiderationYouthChart from '../charts/BankConsideration/BankConsiderationYouthChart'
import BankConsiderationPPTX from '../powerpoint/BankConsiderationPPTX';

const BankConsideration = ({ heading, total, total_youth, total_private }) => {
  const [selectedProvince, setSelectedProvince] = useState('');
  const [selectedLocalMarket, setSelectedLocalMarket] = useState(''); 
  const [ChartDataMain, setChartDataMain] = useState([]);
  const [ChartDataPrivate, setChartDataPrivate] = useState([]);
  const [ChartDataYouthAndMiddle, setChartDataYouthAndMiddle] = useState([]);
  
  useEffect(() => {
    const fetchDataMain = async () => {
      try {
        const response = await axios.get('https://outlook.plus94research.co.za/api/bank-consideration/total/', {
          params: {
            province: selectedProvince,
            local_market: selectedLocalMarket,
          },
        });
        console.log("Total Consideration Data:", response.data);
        setChartDataMain(response.data || []); 
      } catch (error) {
        console.error('Error fetching data for the TOTAL consideration:', error);
        setChartDataMain([]);
      }
    };

    fetchDataMain();
  }, [selectedProvince, selectedLocalMarket]);

  
  useEffect(() => {
    const fetchDataPrivate = async () => {
      try {
        const response = await axios.get('https://outlook.plus94research.co.za/api/bank-consideration/private/', {
          params: {
            province: selectedProvince,
            local_market: selectedLocalMarket,
          },
        });
        // Make sure the response data structure matches what the chart expects
        const privateChartData = response.data.chart_data || []; 
      
        setChartDataPrivate(privateChartData);
      } catch (error) {
        console.error('Error fetching data for PRIVATE consideration:', error);
        setChartDataPrivate([]);
      }
    };

    fetchDataPrivate();
  }, [selectedProvince, selectedLocalMarket]);
  
  useEffect(() => {
    const fetchDataYouthAndMiddle = async () => {
      try {
        const response = await axios.get('https://outlook.plus94research.co.za/api/bank-consideration/youth_main_and_middle/', {
          params: {
            province: selectedProvince,
            local_market: selectedLocalMarket,
          },
        });
        console.log("Youth Consideration Data:", response.data);
        setChartDataYouthAndMiddle(response.data.chart_data || []); 
      } catch (error) {
        console.error('Error fetching data for YOUTH consideration:', error);
        setChartDataYouthAndMiddle([]);
      }
    };

    fetchDataYouthAndMiddle();
  }, [selectedProvince, selectedLocalMarket]);

  return (
    <div className='home'>
      <HomeTopBar />
      <div className='first-mention-heading-div'>
        <h2 className='first-mention-heading'>{heading}</h2>  
      </div>
      
      <div className='filter'>
        <label htmlFor="province-select">Province: </label>
        <select
          id="province-select"
          value={selectedProvince}
          onChange={(e) => setSelectedProvince(e.target.value)}
        >
          <option value="">All</option>
          {Object.keys(provinces).map((province) => (
            <option key={province} value={provinces[province]}>
              {province}
            </option>
          ))}
        </select>

        <label htmlFor="local-market-select">Local Market: </label>
        <select
          id="local-market-select"
          value={selectedLocalMarket}
          onChange={(e) => setSelectedLocalMarket(e.target.value)}
        >
          <option value="">All</option>
          {Object.keys(local_market).map((market) => (
            <option key={market} value={local_market[market]}>
              {market}
            </option>
          ))}
        </select>
      </div> 


      <div>
          <BankConsiderationPPTX
            selectedProvince={selectedProvince}
            selectedLocalMarket={selectedLocalMarket}
            maindata={ChartDataMain}
            privatedata={ChartDataPrivate}
            youthdata={ChartDataYouthAndMiddle}
          />
      </div>

      <div className='three-charts-container'>          

        <div className='three-charts-left-container'>
            <h2 className='first-mention-total'>{total}</h2>     
            <BankConsiderationChart 
                  mainData={ChartDataMain} 
            />   
        </div>  


         <div className='three-charts-right-container'>
            <div>
                <h2 className='first-mention-total'>{total_youth}</h2>        
                <BankConsiderationYouthChart 
                      youthData={ChartDataYouthAndMiddle} 
                />  
            </div>
            <div>
                <h2 className='first-mention-total'>{total_private}</h2>       
                <BankConsiderationPrivateChart 
                      privateData={ChartDataPrivate} 
                />    
            </div>      
        </div>                  

      </div>           
    </div>
  );
};

export default BankConsideration;

